export default __webpack_public_path__ + "static/media/cashening-tile.8c6581dd.png";